// SchedHeader — the one-row header every schedule screen shares with the
// dispatch day board: ‹ label › · tabular totals · actions · ⋯ · a muted note at
// the far right. Classes come from the dispatch chrome so the four screens read
// as one surface.
import React, { useState } from "react";
import { MoreHorizontal } from "lucide-react";

export default function SchedHeader({ label, onPrev, onNext, prevLabel = "Previous", nextLabel = "Next", totals = [], actions = null, menu = [], note = null }) {
  const [open, setOpen] = useState(false);
  const items = menu.filter(Boolean);
  return (
    <header className="dispatch-topbar dispatch-topbar--compact">
      <div className="dispatch-date-nav">
        <button type="button" className="dispatch-date-nav-btn" onClick={onPrev} aria-label={prevLabel}>&larr;</button>
        <span className="dispatch-date-display is-static sc-label">{label}</span>
        <button type="button" className="dispatch-date-nav-btn" onClick={onNext} aria-label={nextLabel}>&rarr;</button>
      </div>
      {totals.length ? (
        <div className="dispatch-topbar-totals" aria-label="Totals">
          {totals.filter(Boolean).map((t, i) => (
            <React.Fragment key={i}>
              {i ? <span className="dispatch-summary-sep">·</span> : null}
              <span>{t}</span>
            </React.Fragment>
          ))}
        </div>
      ) : null}
      <div className="dispatch-actions">
        {actions}
        {items.length ? (
          <div className="dispatch-overflow">
            <button type="button" className="dispatch-date-nav-btn dispatch-overflow-trigger" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-label="More options">
              <MoreHorizontal size={16} />
            </button>
            {open ? (
              <>
                <button type="button" className="dispatch-overflow-backdrop" aria-hidden="true" tabIndex={-1} onClick={() => setOpen(false)} />
                <div className="dispatch-overflow-menu" role="menu">
                  {items.map((it) => (
                    <button key={it.label} type="button" role="menuitem" className={`dispatch-overflow-item ${it.active ? "is-active" : ""}`} disabled={it.disabled} onClick={() => { setOpen(false); it.run(); }}>
                      {it.label}
                    </button>
                  ))}
                </div>
              </>
            ) : null}
          </div>
        ) : null}
      </div>
      {note ? <div className="dispatch-topbar-sync"><span className="dfresh">{note}</span></div> : null}
    </header>
  );
}

/** A dialog in the dispatch chrome (desktop); the phone gets the same body in a Sheet. */
export function SchedDialog({ title, kicker, onClose, children, footer = null }) {
  return (
    <div className="dispatch-modal" role="dialog" aria-modal="true" aria-label={title}>
      <button type="button" className="dispatch-modal-backdrop" onClick={onClose} aria-label={`Close ${title}`} />
      <div className="dispatch-modal-card dispatch-modal-card--sm">
        <header className="dispatch-modal-head">
          <div>
            {kicker ? <div className="dispatch-header-kicker">{kicker}</div> : null}
            <h3>{title}</h3>
          </div>
          <button type="button" className="dispatch-modal-close" onClick={onClose} aria-label={`Close ${title}`}>×</button>
        </header>
        <div className="dispatch-modal-body">{children}</div>
        {footer ? <div className="sc-dialog-foot">{footer}</div> : null}
      </div>
    </div>
  );
}
